export const routes = {
  go_back: '..',
  refresh: '.',

  home: '/',
  about: '/about',
  privacy: '/privacy',
  terms: '/terms',
  contact: '/contact',

  redirect_oauth: '/auth/redirect/login/',

  account: "/account",
  invalid_role: "/account/invalid_role",
  silent_signin: "/account/silent",
  signin: "/account/login",
  new_hotel_owner: "/account/hotel/new",
  signup: "/account/register",
  verify_email: "/account/verify-email",
  forgot_password: "/account/forgot-password",
  reset_password: "/account/reset-password",
  profile: "/profile",
  update_profile: "/profile/update",
}